<template>
  <div class="container">
    <div class="header"><h1>绑定采集盒</h1><p class="subtitle">扫码成功后请完善以下信息</p></div>
    <div class="content">
      <div class="form-group"><label>采集盒类型</label><select v-model="form.boxType"><option>乳牙采集盒</option></select></div>
      <div class="form-group"><label>儿童姓名</label><input v-model="form.childName" placeholder="请输入儿童姓名"></div>
      <div class="form-group"><label>关系</label><select v-model="form.relation"><option>本人</option><option>父子</option><option>母子</option><option>其他</option></select></div>
      <div class="form-group"><label>性别</label><select v-model="form.gender"><option>男</option><option>女</option></select></div>
      <div class="form-group"><label>证件类型</label><select v-model="form.idType"><option>身份证</option><option>护照</option><option>其他</option></select></div>
      <div class="form-group"><label>证件号码</label><input v-model="form.idNumber" placeholder="请输入证件号码"></div>
      <div class="form-group"><label>出生日期</label><input type="date" v-model="form.birthDate"></div>
      <div class="form-group"><label>监护人手机号</label><input type="tel" v-model="form.guardianPhone" placeholder="请输入手机号"></div>
      <button class="btn" @click="submit"><i class="fas fa-link"></i> 绑定</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BindForm',
  data () {
    return {
      form: {
        boxType: '乳牙采集盒',
        childName: '',
        relation: '本人',
        gender: '男',
        idType: '身份证',
        idNumber: '',
        birthDate: '',
        guardianPhone: ''
      }
    }
  },
  methods: {
    submit () {
      if (!this.form.childName) return alert('请填写儿童姓名')
      if (!this.form.idNumber) return alert('请填写证件号码')
      if (!this.form.birthDate) return alert('请选择出生日期')
      if (!this.form.guardianPhone) return alert('请填写监护人手机号')
      this.$router.push({ name: 'BindResult', query: { ok: '1' } })
    }
  }
}
</script>

<style scoped>
.container { height: 110%;  margin: 0 auto; background: #fff; border-radius: 16px; box-shadow: 0 8px 20px rgba(0,0,0,0.06); overflow: auto; }
.header { text-align: center; padding: 20px; background: linear-gradient(135deg, #3498db 0%, #2ecc71 100%); color: #fff; }
.subtitle { opacity: .9; }
.content { padding: 20px; }
.form-group { margin-bottom: 14px; }
.form-group label { display: block; margin-bottom: 6px; color: #555; font-weight: 500; }
.form-group input, .form-group select { width: 100%; padding: 12px; border: 1px solid #ddd; border-radius: 8px; }
.btn { background: linear-gradient(45deg, #3498db 0%, #2ecc71 100%); color: #fff; width: 100%; border: none; padding: 14px; border-radius: 10px; font-size: 16px; }
</style>
